import { getParticipantsArray } from 'helpers/utils';
import { api } from 'store/services/conversation.service';
import { deleteParticipants } from 'store/services/firebase-broadcast';

export function findFirebaseParticipantKey(
  participants: any,
  userPk: string | number
): string | number | null {
  if (participants == null || userPk == null) {
    return null;
  }
  if (Array.isArray(participants)) {
    const index = participants.findIndex(
      (p: any) => p?.pk != null && String(p.pk) === String(userPk)
    );
    return index >= 0 ? index : null;
  }
  const key = Object.keys(participants).find(
    (k) => participants[k]?.pk != null && String(participants[k].pk) === String(userPk)
  );
  return key ?? null;
}

export function matchRoomMember(
  participants: any,
  { email, displayName }: { email?: string; displayName?: string }
): any | null {
  const members = getParticipantsArray(participants);
  const emailNorm = email?.trim().toLowerCase();
  if (emailNorm) {
    const byEmail = members.find(
      (m: any) => m?.email && String(m.email).trim().toLowerCase() === emailNorm
    );
    if (byEmail) return byEmail;
  }
  const nameNorm = displayName?.trim().toLowerCase();
  if (nameNorm) {
    const byName = members.find(
      (m: any) => m?.name && String(m.name).trim().toLowerCase() === nameNorm
    );
    if (byName) return byName;
  }
  return null;
}

/**
 * Increment number_of_eviction via rooms/remove-guest, then drop the member from Firebase.
 * Throws if the API fails so callers can keep the member in the room.
 */
export async function removeGuestFromRoom(params: {
  userId: string | number;
  roomId: string | number;
  firebaseParticipantId?: string | number | null;
  participants?: any;
}): Promise<void> {
  await api.removeGuestRequest({
    user_id: String(params.userId),
    room_id: String(params.roomId),
  });

  const firebaseKey =
    params.firebaseParticipantId != null && params.firebaseParticipantId !== ''
      ? params.firebaseParticipantId
      : findFirebaseParticipantKey(params.participants, params.userId);

  if (firebaseKey != null) {
    await deleteParticipants({
      roomId: params.roomId,
      participantId: firebaseKey,
    });
  }
}
